import React from 'react'
import SelectionStoreProvider, {
  useSelectionStore
} from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { useParams } from 'react-router'
import { Switch } from 'react-router-dom'
import { SubPrivateRoute } from 'routes/PrivateRoute'
import { MANAGER } from 'constants/roles'
import {
  NEW_SEO,
  NEW_WL,
  SELECTION_STEP_PATH_LOADED
} from 'routes/constants.routes'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import NewSeo from 'pages/Desktop/Selection/Manager/pages/NewSeo'
import CarSelectionHeader from 'pages/Desktop/Selection/Manager/components/CarSelectionHeader/CarSelectionHeader'
import CarFilter from 'pages/Desktop/Selection/Manager/pages/CarFilter'
import Demonstration from 'pages/Desktop/Selection/Manager/pages/Demonstration'
import CarSelection from 'pages/Desktop/Selection/Manager/pages/CarSelection'
import Paperwork from 'pages/Desktop/Selection/Manager/pages/Paperwork'
import NewWL from 'pages/Desktop/Selection/Manager/pages/NewWL'

const SelectionMnDesktop = props => (
  <SelectionStoreProvider {...props}>
    <Selection />
  </SelectionStoreProvider>
)

export default SelectionMnDesktop

const Selection = () => {
  const {
    store: { initLoad }
  } = useSelectionStore()
  const { step, id } = useParams()

  return initLoad ? (
    <LoaderBackdrop loading={initLoad} />
  ) : (
    <Switch>
      <SubPrivateRoute
        byRole={MANAGER}
        component={NewWL}
        path={SELECTION_STEP_PATH_LOADED(id)[NEW_WL]}
      />
      <SubPrivateRoute
        byRole={MANAGER}
        component={NewSeo}
        path={SELECTION_STEP_PATH_LOADED(id)[NEW_SEO]}
      />

      {step !== NEW_SEO && step !== NEW_WL && (
        <PageContainerDesktop
          customHeader={<CarSelectionHeader />}
          style={{ position: 'relative', height: '100vh' }}
        >
          <Switch>
            <SubPrivateRoute
              byRole={MANAGER}
              component={CarFilter}
              path={SELECTION_STEP_PATH_LOADED(id)[0]}
            />{' '}
            <SubPrivateRoute
              byRole={MANAGER}
              component={Demonstration}
              path={SELECTION_STEP_PATH_LOADED(id)[1]}
            />{' '}
            <SubPrivateRoute
              byRole={MANAGER}
              component={CarSelection}
              path={SELECTION_STEP_PATH_LOADED(id)[2]}
            />{' '}
            <SubPrivateRoute
              byRole={MANAGER}
              component={Paperwork}
              path={SELECTION_STEP_PATH_LOADED(id)[3]}
            />
          </Switch>
        </PageContainerDesktop>
      )}
    </Switch>
  )
}
